import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close-circle-2.svg'
import _imports_1 from '../../../assets/img/icons/download.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "salesReturnDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "salesReturnDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content sales-return-details-modal" }
const _hoisted_4 = { class: "modal-header border-0 pb-0" }
const _hoisted_5 = {
  class: "modal-title text-title mt-3 mb-2",
  id: "salesReturnDetailsModalLabel"
}
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_10 = { class: "row g-3 mb-4" }
const _hoisted_11 = { class: "col-md-3 col-6" }
const _hoisted_12 = { class: "summary-card" }
const _hoisted_13 = { class: "summary-label" }
const _hoisted_14 = { class: "summary-value" }
const _hoisted_15 = { class: "col-md-3 col-6" }
const _hoisted_16 = { class: "summary-card" }
const _hoisted_17 = { class: "summary-label" }
const _hoisted_18 = { class: "summary-value" }
const _hoisted_19 = { class: "col-md-3 col-6" }
const _hoisted_20 = { class: "summary-card" }
const _hoisted_21 = { class: "summary-label" }
const _hoisted_22 = { class: "summary-value" }
const _hoisted_23 = { class: "col-md-3 col-6" }
const _hoisted_24 = { class: "summary-card" }
const _hoisted_25 = { class: "summary-label" }
const _hoisted_26 = { class: "summary-value" }
const _hoisted_27 = { class: "details-section mb-4" }
const _hoisted_28 = { class: "section-header" }
const _hoisted_29 = { class: "section-title mb-1" }
const _hoisted_30 = { class: "section-subtitle mb-0" }
const _hoisted_31 = { class: "table-responsive sales-return-items-table" }
const _hoisted_32 = { class: "table align-middle mb-0" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "details-section" }
const _hoisted_40 = { class: "row g-3" }
const _hoisted_41 = { class: "col-md-8" }
const _hoisted_42 = { class: "section-title mb-2" }
const _hoisted_43 = { class: "note-block mb-0" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "totals-card" }
const _hoisted_46 = { class: "total-row" }
const _hoisted_47 = { class: "total-row" }
const _hoisted_48 = { class: "total-row" }
const _hoisted_49 = { class: "total-row" }
const _hoisted_50 = { class: "total-row grand" }
const _hoisted_51 = { class: "modal-footer border-0 pt-0" }
const _hoisted_52 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_53 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-badge", `status-${_ctx.statusValue}`])
            }, _toDisplayString(_ctx.formatStatus(_ctx.salesReturn?.status)), 3),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("sales_return_page.sales_return_label")) + " " + _toDisplayString(_ctx.salesReturn?.return_ref || ""), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.salesReturn?.reference_no || _ctx.salesReturn?.sale?.reference_no || _ctx.$t("sales_return_page.not_available_short")) + " • " + _toDisplayString(_ctx.formatDateTime(_ctx.salesReturn?.created_at)), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close p-0",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.$t('common.close')
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7)
        ]),
        (_ctx.salesReturn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("sales_return_page.customer")), 1),
                    _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.salesReturn.customer_name || _ctx.salesReturn.customer?.name || _ctx.$t("sales_return_page.not_available_short")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("sales_return_page.warehouse")), 1),
                    _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.salesReturn.warehouse_name || _ctx.salesReturn.warehouse?.name || _ctx.$t("sales_return_page.not_available_short")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("sales_return_page.sale_reference")), 1),
                    _createElementVNode("strong", _hoisted_22, _toDisplayString(_ctx.salesReturn.reference_no || _ctx.salesReturn.sale?.reference_no || _ctx.$t("sales_return_page.not_available_short")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("sales_return_page.grand_total")), 1),
                    _createElementVNode("strong", _hoisted_26, "$" + _toDisplayString(Number(_ctx.salesReturn.grand_total || 0).toFixed(2)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", _hoisted_29, _toDisplayString(_ctx.$t("sales_return_page.returned_items")), 1),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("sales_return_page.review_returned_items")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("table", _hoisted_32, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("th", null, "#", -1)),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("sales_return_page.product")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("sales_return_page.code")), 1),
                        _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("sales_return_page.qty")), 1),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("sales_return_page.unit_price")), 1),
                        _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("sales_return_page.subtotal")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesReturn.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${item.product_id}-${index}`
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(item.product_name || item.product?.name || _ctx.$t("sales_return_page.not_available_short")), 1),
                          _createElementVNode("td", null, _toDisplayString(item.product_code || item.product?.code || _ctx.$t("sales_return_page.not_available_short")), 1),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(item.quantity), 1),
                          _createElementVNode("td", _hoisted_37, "$" + _toDisplayString(Number(item.unit_price || 0).toFixed(2)), 1),
                          _createElementVNode("td", _hoisted_38, "$" + _toDisplayString(Number(item.subtotal || item.total || 0).toFixed(2)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("h6", _hoisted_42, _toDisplayString(_ctx.$t("sales_return_page.notes")), 1),
                    _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.salesReturn.note || _ctx.$t("sales_return_page.no_notes_added")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.subtotal")), 1),
                        _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.salesReturn.total || 0).toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.discount")), 1),
                        _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.salesReturn.discount || _ctx.salesReturn.total_discount || 0).toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.tax")), 1),
                        _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.salesReturn.tax || 0).toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.shipping")), 1),
                        _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.salesReturn.shipping || 0).toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.grand_total")), 1),
                        _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.salesReturn.grand_total || 0).toFixed(2)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("button", _hoisted_52, _toDisplayString(_ctx.$t("common.close")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn style-five upload-btn px-xxl-6",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printSalesReturn && _ctx.printSalesReturn(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("sales_return_page.print")) + " ", 1),
            _createElementVNode("img", {
              src: _imports_1,
              alt: _ctx.$t('sales_return_page.print')
            }, null, 8, _hoisted_53)
          ])
        ])
      ])
    ])
  ]))
}